module.exports = __webpack_public_path__ + "media/spotlight.9f7e8d48.mp3";